import config from "emun.auth/auth.config";
import form from "emun.auth/retailer-approval.formio";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import formioController from "webforms/formio/formio.controller";

export default class RetailerApprovalController {
  constructor($scope, options) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    console.debug("RetailerApprovalController", {
      $scope,
      form,
      $ctrl,
      options,
    });
    $ctrl.bus = new ServiceBus();
    $ctrl.$appConfig = $appConfig;
    $ctrl.config = config;
    $ctrl.formProcessing = false;
    $ctrl.title = options.title || " Required Approval...";
    $ctrl.retailer = options.retailer || {};

    if ($ctrl.language === undefined) {
      $ctrl.language = "en";
    }
    $ctrl.exportText =
      $ctrl.language === "fr" ? "EXPORTER EN PDF" : "EXPORT TO PDF";

    let formioId = form.formioId;
    if (
      $ctrl.retailer &&
      $ctrl.retailer.tags &&
      $ctrl.retailer.tags.ApprovalFormioId
    ) {
      formioId = $ctrl.retailer.tags.ApprovalFormioId[0];
    }

    console.debug(
      "formioId",
      formioId,
      $ctrl.retailer &&
        $ctrl.retailer.tags &&
        $ctrl.retailer.tags.ApprovalFormioId
    );

    if (formioId) {
      $ctrl.getFormIO(formioId).then((f) => {
        if (f) {
          $ctrl.form = f.fields;
          $ctrl.submission.form = formioId;
          $ctrl.submission.label = formioId;
          $ctrl.submission.formType = form.formType;
        }
      });
    } else {
      $ctrl.form = form;
    }

    $ctrl.submissionId = $ctrl.retailer.tags.ApprovalForm;
    $ctrl.submission = {
      label: formioId || "retailer-approval",
      data: {
        retailerId: $ctrl.retailer.id,
        panelPanelColumnsSalesRepforRequestingDealer:
          $ctrl.retailer.salesRep.id || "",
        salesRep: {
          label: $ctrl.retailer.salesRep.name || "",
          value: $ctrl.retailer.salesRep.id || "",
        },
        panelPanelColumnsCurrentStatus: $ctrl.retailer.customerType,
      },
    };
    if ($ctrl.submissionId) {
      $ctrl.bus
        .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
        .then(({ data }) => {
          if (data.results.length) {
            $ctrl.submission.data = data.results[0].data;
            $ctrl.submission.data.panelPanelColumnsCurrentStatus =
              $ctrl.retailer.customerType;
          }
        });
    }

    $ctrl.statuses = [];
    $ctrl.salesreps = [];
    $ctrl.priceListValues = [];

    $ctrl.bus
      .send("QueryRegistrationStatuses.json?OrderBy=SortOrder")
      .then(function (response) {
        $ctrl.statuses = response.data.results;
        $ctrl.bus.send("QueryPaymentTerms.json").then(function (termsResults) {
          var termsValues = [];
          termsResults.data.results.forEach(function (obj) {
            termsValues.push({ value: obj.id, label: obj.name });
          });
          $ctrl.submission.data.paymentTermsValues = termsValues;
        });

        $ctrl.bus
          .send("QueryPriceLists.json?GroupBy=PriceListId&OrderBy=PriceListId")
          .then(function (pri) {
            //$ctrl.priceListValues = response.data.results;
            var values = [];
            pri.data.results.forEach(function (obj) {
              values.push({ value: obj.priceListId, label: obj.priceListId });
            });
            $ctrl.submission.data.priceListValues = values;
            console.info(
              "$ctrl.submission.data.priceListValues",
              $ctrl.submission.data.priceListValues
            );
            $ctrl.bus
              .send("QuerySalesRepList.json?Active=1&OrderBy=Name")
              .then(function (res) {
                var values = [];
                res.data.results.forEach(function (obj) {
                  values.push({ value: obj.id, label: obj.name });
                });
                $ctrl.submission.data.salesRepValues = values;

                $ctrl.submission.data.panelPanelColumnsSelectNewStatus =
                  $ctrl.retailer.customerType;
                $ctrl.submission.data.accountType = $ctrl.retailer.accountType;
                if ($ctrl.retailer.salesRep.id) {
                  $ctrl.submission.data.panelPanelColumnsSalesRepforRequestingDealer =
                    {
                      value: $ctrl.retailer.salesRep.id,
                      label: $ctrl.retailer.salesRep.name,
                    };
                  $ctrl.submission.data.salesRep = {
                    value: $ctrl.retailer.salesRep.id,
                    label: $ctrl.retailer.salesRep.name,
                  };
                }
                if (formioId) {
                  $ctrl.getFormIO(formioId).then((f) => {
                    if (f) {
                      $ctrl.form = f.fields;
                    }
                    $ctrl.formConfigReady(f);
                  });
                } else {
                  $ctrl.form = form;
                  $ctrl.formConfigReady(form);
                }
              });
          });
      });
  }

  formConfigReady(form) {
    const $ctrl = this;
    console.debug("formConfigReady", { $ctrl, form });
    $ctrl.form.components[0].components[0].columns[1].components.forEach(
      function (section) {
        if (section.key === "panelPanelColumnsSelectNewStatus") {
          section.values = [];
          if ($ctrl.$session.isCorpOrAbove()) {
            section.values = [
              { value: "Rep Assigned", label: "Rep Assigned", shortcut: "" },
              { value: "Rep Declined", label: "Rep Declined", shortcut: "" },
              { value: "Rep Approved", label: "Rep Approved", shortcut: "" },
              {
                value: "Credit Approved",
                label: "Credit Approved",
                shortcut: "",
              },
              {
                value: "Credit Declined",
                label: "Credit Declined",
                shortcut: "",
              },
              { value: "Completed", label: "Completed", shortcut: "" },
              { value: "Not Approved", label: "Not Approved", shortcut: "" },
            ];
          } else if (
            $ctrl.$session.isRep() &&
            $ctrl.retailer.customerType.toUpperCase() === "REQUEST"
          ) {
            section.values = [
              { value: "Rep Declined", label: "Rep Declined", shortcut: "" },
              { value: "Rep Approved", label: "Rep Approved", shortcut: "" },
            ];
          }
        }
      }
    );
    if ($ctrl.statuses.length > 0) {
      $ctrl.form.components[0].components[0].columns[1].components.forEach(
        function (section) {
          if (section.key === "panelPanelColumnsSelectNewStatus") {
            section.values = [];
            $ctrl.statuses.forEach(function (status) {
              if (status.roles.length) {
                if ($ctrl.$session.hasRole(status.roles)) {
                  section.values.push({
                    value: status.name,
                    label: status.name,
                    shortcut: "",
                  });
                }
              } else {
                section.values.push({
                  value: status.name,
                  label: status.name,
                  shortcut: "",
                });
              }
            });
          }
        }
      );
    }
  }

  formSubmission(e, submission) {
    const $ctrl = this;
    console.debug("formSubmission", { $ctrl, e, submission });
    submission.data.retailerId = $ctrl.retailer.id;
    $ctrl.submission = submission;
    $ctrl.$broadcast("$retailerApprovalSubmitted", submission.data);
    $ctrl.$dismiss();
  }

  exportQuickReport(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strCustomerID=" +
        $ctrl.retailer.id
    );

    return (location.href = url);
  }

  exportForm() {
    const $ctrl = this;
    html2canvas(document.querySelector("#registrationForm")).then((canvas) => {
      var doc = new jsPDF({
        unit: "px",
        format: "a4",
      });
      var maxWidth = doc.internal.pageSize.getWidth();
      var maxHeight = doc.internal.pageSize.getHeight();
      var newDims = $ctrl.calculateAspectRatioFit(
        canvas.width,
        canvas.height,
        maxWidth,
        maxHeight
      );
      doc.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        0,
        0,
        newDims.width,
        newDims.height
      );
      doc.save("approval.pdf");
    });
  }
}
